module.exports = __webpack_public_path__ + "img/icon8.98f754b5.png";